import React, { FC, useContext, useEffect, useState } from "react";
import { Context } from "../../..";
import { IBlocks, IContent, IHeader } from "../../../models/IPages";
import { createFileFromBase64, getImageExtensionFromBase64, removeKeyFromObject } from "../../../utils";
import Spinner from "../../../components/UI/spinner/Spinner";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Button from "../../../components/UI/button/GgButton";
import FifthBlock from "../blocks/FifthBlock";
import FourthBlock from "../blocks/FourthBlock";
import InfoBlock from "../blocks/InfoBlock";
import ArticlesBlock from "../blocks/ArticlesBlock";
import HeaderBlock from "../blocks/HeaderBlock";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import { observer } from "mobx-react-lite";
import CalculatorsBlock from "../blocks/CalculatorsBlock";
import GuideBlock from "../blocks/GuideBlock";

const FirstHome: FC = () => {
  const { pages, articles, store, roles } = useContext(Context);
  const [adminPermissionData, setAdminPermissionData] = useState<any>()
  const categoryType = window.location.pathname.split("/").pop() || "";

  const [headerBlock, setHeaderBlock] = React.useState<IHeader>({
    title: "",
    mainImage: "",
    images: [],
  });
  const [articlesBlock, setArticlesBlock] = React.useState<IBlocks>({
    title: "",
    content: Array.from({ length: 3 }, () => ({
      image: "",
      heading: "",
      description: "",
      link: "1",
    })),
    images: [],
  });
  const [infoBlock, setInfoBlock] = React.useState<IBlocks>({
    title: "",
    content: Array.from({ length: 3 }, () => ({
      heading: "",
      description: "",
      link: "",
    })),
    images: [],
  });
  const [fourthBlock, setFourthBlock] = React.useState<IContent>({
    image: "",
    heading: "",
    description: "",
    link: "",
    images: [],
  });
  const [fifthBlock, setFifthBlock] = React.useState<IBlocks>({
    title: "",
    subtitle: "",
    content: Array.from({ length: 3 }, () => ({
      image: "",
      heading: "",
      description: "",
      link: "",
    })),
    images: [],
  });
  const [calculatorBlock, setCalculatorBlock] = React.useState<any>([]);
  const [guideBlock, setGuideBlock] = React.useState<IContent>({
    image: "",
    heading: "",
    description: "",
    link: "",
    images: [],
  });

  const [articleList, setArticleList] = React.useState<any[]>([]);

  useEffect(() => {
    pages
      .loadList(categoryType)
      .then((res: any) => {
        handleFillData(res.content);
      })
      .catch(console.log);
    articles
      .loadList()
      .then((res: any) => {
        setArticleList(
          res.result.map((item: any) => {
            return {
              value: item._id,
              label: item.name,
            };
          })
        );
      })
      .catch(console.log);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData();
    [
      headerBlock,
      articlesBlock,
      infoBlock,
      fourthBlock,
      fifthBlock,
      calculatorBlock,
      guideBlock,
    ].forEach((object, index) => {
      // remove base64 images from object
      const filteredObject = removeKeyFromObject(object, "images");
      // Convert object data to JSON string
      const objectData = JSON.stringify(filteredObject);
      const objectKey = Object.keys({
        headerBlock,
        articlesBlock,
        infoBlock,
        fourthBlock,
        fifthBlock,
        calculatorBlock,
        guideBlock,
      })[index];

      formData.append(objectKey, objectData);
      // Add images to the FormData
      if (object?.images && object.images.length > 0) {
        object.images.forEach((base64Image: string, imageIndex: number) => {
          if (base64Image) {
            let base64Data =
              base64Image?.split(",")?.[1] ||
              base64Image?.split(";base64,").pop() ||
              "";
            const ext = getImageExtensionFromBase64(base64Image);
            const image = createFileFromBase64(
              base64Data,
              `${objectKey}${imageIndex + 1}.${ext || "jpg"}`,
              `image/${ext || "jpg"}`
            );

            formData.append(`${objectKey}${imageIndex + 1}`, image);
          }
        });
      }
    });

    pages
      .updateOne(categoryType, formData)
      .then(() => {
        pages
          .loadList(categoryType)
          .then((res: any) => {
            handleFillData(res.content);
          })
          .catch(console.log);
      })
      .catch(console.log);
  };

  const handleFillData = (content: any) => {
    if (content) {
      setHeaderBlock(content[0].headerBlock);
      setArticlesBlock(content[1].articlesBlock);
      setInfoBlock(content[2].infoBlock);
      setFourthBlock(content[3].fourthBlock);
      setFifthBlock(content[4].fifthBlock);
      setCalculatorBlock(content[5].calculatorBlock);
      setGuideBlock(content[6].guideBlock);
    }
  };

  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "pages")?.children?.find((child: any) => child.path === "first-home")
    setAdminPermissionData(userData)
  };

  return (
    <div>
      {Object.keys(pages.pageContent).length > 0 &&
      !pages.loadingContentBool ? (
        <form className="body" onSubmit={handleSave}>
          <HeaderBlock
            data={headerBlock}
            setData={setHeaderBlock}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <ArticlesBlock
            data={articlesBlock}
            setData={setArticlesBlock}
            articles={articleList}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <InfoBlock
            data={infoBlock}
            setData={setInfoBlock}
            articles={articleList}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <FourthBlock
            data={fourthBlock}
            setData={setFourthBlock}
            articles={articleList}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <FifthBlock
            data={fifthBlock}
            setData={setFifthBlock}
            articles={articleList}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <CalculatorsBlock
            data={calculatorBlock}
            setData={setCalculatorBlock}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <GuideBlock
            data={guideBlock}
            setData={setGuideBlock}
            articles={articleList}
            categoryType={categoryType}
            actionData = {adminPermissionData}
          />

          <div className="btn-container">
          {adminPermissionData?.edit ? (
            <Button className="button" label="Save" type="submit" />
          ) : "" }
          </div>
        </form>
      ) : Object.keys(pages.pageContent).length === 0 &&
        !pages.loadingContentBool ? (
        <Emptiness icon={Timofey} content="It's time to create some content!" />
      ) : (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default observer(FirstHome);
